export default class EditPlaceStrategy {
  constructor(store) {
    this.store = store;
  }

  save(form) {
    return this.store.dispatch('place/update', { place: form, type: form.type });
  }
}
